import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './services/store/store'

import './index.css';
import installBreadcrumbs from './monitoring/installBreadcrumbs';

// Breadcrumbs: record route changes + control clicks so an error report shows
// HOW the user got there. Labels only, never values.
installBreadcrumbs();

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApplication = () => {
	root.render(
		<Provider store={store}>
			<React.StrictMode>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</React.StrictMode>
		</Provider>
	)
}

// Never block mounting the portal on a permissions request. On a hard refresh
// the request can be slow (or hang while the connection is recovering), but
// users must still receive the normal application shell and current route.
// `useMyModules` fetches and applies the authoritative access list in the
// background after the portal has mounted.
renderApplication()

// --------------When make build open comment function in app and useractivity file
